import { useEffect, useRef, useState } from "preact/hooks";
import { useStore } from "@nanostores/preact";
import { $compass, $compassSaving, addMark, saveCompass, validMarkName } from "../state/compass";

/** One-line name input that adds a compass mark at pos (spec 2e §2.4); shared by the menu and the P panel. */
export function AddMarkForm(props: { defaultName: string; pos: [number, number]; onDone(): void }) {
  const [name, setName] = useState(props.defaultName);
  const [busy, setBusy] = useState(false);
  const saving = useStore($compassSaving);
  const input = useRef<HTMLInputElement>(null);
  // autofocus is honoured once per page load; focus by hand so every opening takes typing, Enter and Esc
  useEffect(() => { input.current?.focus(); input.current?.select(); }, []);
  const ok = validMarkName(name);
  async function submit(e: Event) {
    e.preventDefault();
    if (!ok || busy || saving) return;
    setBusy(true);
    const saved = await saveCompass(addMark($compass.get(), name, props.pos));
    setBusy(false);
    if (saved) props.onDone();
  }
  return (
    <form class="add-mark" onSubmit={(e) => void submit(e)}
      onKeyDown={(e) => { if (e.key === "Escape") { e.stopPropagation(); props.onDone(); } }}>
      <input type="text" aria-label="標記名稱" value={name} ref={input} onInput={(e) => setName((e.target as HTMLInputElement).value)} />
      <button type="submit" disabled={!ok || busy || saving}>加入</button>
      <button type="button" class="secondary" onClick={props.onDone}>取消</button>
      {!ok && <p class="hint">名稱要 1–24 個字，不能含控制或格式字元（例如組合 emoji）</p>}
    </form>
  );
}
